import { seriesValueGetter } from './series-getter';
import { DealsSeries } from '../../../helpers/deals/series';
import { ValueGetterParamsWithSeries } from './value-getters.interface';
import { isDefined } from '../../../utils/utils';

export function sectorValueGetter(
  node: ValueGetterParamsWithSeries
): string[] | undefined {
  // Handle null or undefined values
  if (!isDefined(node.data)) {
    return [];
  }

  let subSectorData: DealsSeries.Sector.SubSector[] = seriesValueGetter(
    'subSectors'
  )(node)
    .map((subSectorCode: string) => {
      const data: DealsSeries.Sector.SubSector = DealsSeries.Sector.getSubSectors()[
        subSectorCode
      ];

      if (!data) {
        console.error('Could not find sub sector mapping for: ', subSectorCode);
      }

      return data;
    })
    .filter((data: DealsSeries.Sector.SubSector) => !!data);

  const filteredSubSectorData = subSectorData.filter(
    (data: DealsSeries.Sector.SubSector) => !data.ignorable
  );

  if (filteredSubSectorData.length) {
    subSectorData = filteredSubSectorData;
  }

  return subSectorData.reduce(
    (acc: string[], subSector: DealsSeries.Sector.SubSector) => {
      const sector: string = subSector.sector;

      if (acc.indexOf(sector) === -1) {
        acc.push(sector);
      }

      return acc;
    },
    []
  );
}
